import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import NomineeOptOutDetails from './NomineeOptOutDetails';
import VerifyOtp from './VerifyOtp';
import ApplicationPreview from './ApplicationPreview';
import ProtectedRoute from '../../routes/ProtectedRoute';


export default function NomineeOptOutRouter(): JSX.Element {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route
                exact
                path={path}
                render={(props: any) => (
                    <Redirect to={`${path}/:nomineeOptOutId/investor-details`} from={props.location.state} />
                )}
            />
            <Route
                path={`${path}/:nomineeOptOutId/investor-details`}
                component={NomineeOptOutDetails}
            />
            <Route
                path={`${path}/:nomineeOptOutId/validate-otp`}
                component={VerifyOtp}
            />
            <ProtectedRoute
                path={`${path}/:nomineeOtpOutId/application-preview`}
                component={ApplicationPreview}
                customAuthorizationCheck
            />
        </Switch>
    );
}
